import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { SEOHead } from "@/components/SEOHead";
import { toast } from "sonner";

export default function Register() {
  const { register } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created!");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign up failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <SEOHead title="Create Account | Cocoamaya Patisserie" noindex />
      <p className="eyebrow mb-3">Join the bakery</p>
      <h1 className="font-display text-4xl mb-10">Create an account</h1>
      <form onSubmit={submit} className="space-y-4">
        <input className="input-field" placeholder="Full name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" />
        <input className="input-field" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" />
        <input className="input-field" type="password" placeholder="Password (min 6 chars)" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" />
        <button className="btn-primary w-full justify-center" disabled={submitting} data-testid="reg-submit">
          {submitting ? "Creating account…" : "Create account"}
        </button>
      </form>
      <p className="mt-8 text-sm" style={{ color: "var(--ink-soft)" }}>
        Have an account? <Link to="/login" className="underline" data-testid="goto-login">Sign in</Link>
      </p>
    </div>
  );
}
